export default __webpack_public_path__ + "static/media/2.2c735afe.png";